import { ButtonGroup } from '@mui/material';
import { PERIOD_TYPE_CHOICES } from 'admin/utils';
import { AuthContext } from 'common/providers/AuthContextProvider/AuthContextProvider';
import { CashFlowAdjustment, Role, useCurrentUserQuery } from 'generated/graphql';
import { useContext } from 'react';
import { Datagrid, DateField, DeleteButton, EditButton, FunctionField, SelectField, TextField } from 'react-admin';

interface CashFlowAdjustmentDatagridProps {
  type: 'credit' | 'debit';
}

export const CashFlowAdjustmentDatagrid: React.FC<CashFlowAdjustmentDatagridProps> = ({ type }) => {
  const { isAuthenticated } = useContext(AuthContext);
  const { data } = useCurrentUserQuery({ skip: !isAuthenticated });

  const hasAnyRole = (allowedRoles: Role[]) =>
    isAuthenticated && data?.user?.roles?.some((role: Role) => allowedRoles.includes(role));

  const showEditButton = hasAnyRole([Role.RoleFinancialAdvisor, Role.RoleAdmin]);
  const showDeleteButton = hasAnyRole([Role.RoleFinancialAdvisor, Role.RoleAdmin]);

  return (
    <Datagrid
      bulkActionButtons={false}
      rowClick="show"
      sx={{
        '& .RaDatagrid-headerCell': {
          backgroundColor: '#eeeeee',
          width: '2em',
          wordBreak: 'break-all',
        },

        '& .RaDatagrid-rowCell > *': {
          display: 'block',
          minWidth: '100%',
        },
      }}
    >
      <TextField label="ID" source="id" width="2em" />
      <DateField label="Dátum vytvorenia" locales="sk" source="creationTimestamp" width="3em" />
      <DateField label="Dátum zmeny" locales="sk" source="updateTimestamp" width="3em" />
      <TextField label={type == 'debit' ? 'Druh výdavku' : 'Druh činnosti'} source="text" width="4em" />
      <FunctionField
        label="Suma"
        render={(record: CashFlowAdjustment) =>
          record.period.expectedAmount?.amount
            ? type == 'debit'
              ? -record.period.expectedAmount.amount
              : record.period.expectedAmount.amount
            : undefined
        }
        source="period.expectedAmount.amount"
        width="2em"
      />
      <DateField label="Prvá platba" locales="sk" source="period.referenceDate" width="3em" />
      <TextField label="Opakovať každých" source="period.periodCount" width="3em" />
      <SelectField choices={PERIOD_TYPE_CHOICES} label="" source="period.periodTypeCode" width="2em" />
      {(showEditButton || showDeleteButton) && (
        <ButtonGroup sx={{ textAlign: 'right', width: '6em' }}>
          {showEditButton && <EditButton centerRipple={true} variant="text" />}
          {showDeleteButton && <DeleteButton mutationMode="pessimistic" redirect="" variant="text" />}
        </ButtonGroup>
      )}
    </Datagrid>
  );
};
